module.exports = __webpack_public_path__ + "img/ve.80a66587.svg";